import { FilaStatus, TicketStatus } from "../types";

// Uma cor por status, usada nas abas da fila e no badge do atendimento. As abas
// só existem para os status da fila; triagem e resolvido aparecem só em badge.
// Mesmo esquema bg-<cor>-100 / text-<cor>-700 do LastStageBadge (offer-tracking).
// As classes ficam literais para o Tailwind encontrá-las no build.

export const STATUS_TAB: Record<FilaStatus, string> = {
  waiting_agent:
    "text-amber-700 data-[state=active]:bg-amber-100 data-[state=active]:text-amber-800 dark:text-amber-400 dark:data-[state=active]:bg-amber-950/40 dark:data-[state=active]:text-amber-300",
  open: "text-blue-700 data-[state=active]:bg-blue-100 data-[state=active]:text-blue-800 dark:text-blue-400 dark:data-[state=active]:bg-blue-950/40 dark:data-[state=active]:text-blue-300",
  closed:
    "text-slate-600 data-[state=active]:bg-slate-200 data-[state=active]:text-slate-800 dark:text-slate-400 dark:data-[state=active]:bg-slate-800 dark:data-[state=active]:text-slate-200",
};

export const STATUS_BADGE: Record<TicketStatus, string> = {
  waiting_agent: "bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300",
  open: "bg-blue-100 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300",
  triage: "bg-violet-100 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300",
  closed: "bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  resolved: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300",
};
